// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';

const requiredPart = t.interface({
  approvedTo: t.union([DateSchema, t.null]),
});

export const UpdateSubjectMemberSchema = excess(requiredPart);

export interface UpdateSubjectMember extends t.TypeOf<typeof UpdateSubjectMemberSchema> {}
